export const INVITATIONS_TAG_TYPES = {
  SUPER_ADMIN_INVITES: 'SuperAdminInvites',
  ORGANISATION_INVITES: 'OrganisationInvites',
  FEEDBACK_FRAMEWORK_INVITES: 'FeedbackFrameworkInvites',
  CULTURE_PROJECT_INVITES: 'CultureProjectInvites',
};

export const ORGANISATION_ACTIVITY_LOG_ITEMS_TAG_TYPES = {
  ORGANISATION_PROJECTS: 'OrganisationProjects',
  ORGANISATION_USERS: 'OrganisationUsers',
};

export const API_TAG_TYPES = {
  // activityLogApi
  ACTIVITY_LOGS: 'ActivityLogs',

  // dashboardApi
  MASTER_DASHBOARD: 'MasterDashboard',
  MASTER_DASHBOARD_CULTURAL_PROJECTS: 'MasterDashboardCulturalProjects',
  DASHBOARD_PORTFOLIO: 'DashboardPortfolio',
  PERSONAL_TRACKER: 'PersonalTracker',
  PROJECT_DASHBOARD: 'ProjectDashboard',
  PROJECT_DASHBOARD_KEY_AREA_GRAPH: 'ProjectDashboardKeyAreaGraph',
  PROJECT_DASHBOARD_KEY_AREA_HEATMAP: 'ProjectDashboardKeyAreaHeatmap',
  ORGANISATION_PORTFOLIO: 'OrganisationPortfolio',
  ORGANISATION_PORTFOLIO_CULTURE_PROJECTS: 'OrganisationPortfolioCultureProjects',
  ORGANISATION_PORTFOLIO_GRAPH: 'OrganisationPortfolioGraph',

  // feedbackFrameworkApi
  FEEDBACK_FRAMEWORK: 'FeedbackFramework',
  NOMINEES_SETTINGS: 'NomineesSettings',
  FRAMEWORK_NOMINEES: 'FrameworkNominees',
  FRAMEWORK_USERS: 'FrameworkUsers',
  PERSONAL_JOURNALS: 'PersonalJournals',
  PERSONAL_JOURNAL: 'PersonalJournal',

  // organisationsApi
  ORGANISATIONS: 'Organisations',
  SECURITY_SETTINGS: 'SecuritySettings',
  ORGANISATION_ACTIVITY_LOGS: 'OrganisationActivityLogs',
  ...ORGANISATION_ACTIVITY_LOG_ITEMS_TAG_TYPES,

  // projectsApi
  CULTURE_PROJECT: 'CultureProject',
  PROJECT_USERS: 'ProjectUsers',
  KEY_EVENTS: 'KeyEvents',
  PROJECTS_JOURNALS: 'ProjectsJournals',
  PROJECTS_JOURNAL_ENTRIES_LIST: 'ProjectsJournalEntriesList',
  ACTION_OWNERS: 'ActionOwners',
  ACTION_TRACKER: 'ActionTracker',
  ACTION_TRACKER_SEGMENTS: 'ActionTrackerSegments',

  // usersApi
  CURRENT_USER: 'CurrentUser',
  SUPER_ADMINS: 'SuperAdmins',
  ...INVITATIONS_TAG_TYPES,
};
